import Component from './component.vue';
import Props from './props';

export * from './enums';
export { Props };
export default Component;



// WEBPACK FOOTER //
// ./src/components/calendar/text/index.ts